module.exports = __webpack_public_path__ + "static/img/bg_forest.80be7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail/bg_forest.png
// module id = 3MI3
// module chunks = 0